import {
  createExchangeRateService,
  deleteExchangeRateService,
  getExchangeRatesService,
  updateExchangeRateService,
} from "@/services/exchange-rates.service";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";

const EXCHANGE_RATES_KEY = ["exchange-rates"] as const;

interface ExchangeRateFilters {
  limit?: number;
  offset?: number;
}

export const useExchangeRates = (filters: ExchangeRateFilters = {}) =>
  useQuery({
    queryKey: [...EXCHANGE_RATES_KEY, filters],
    queryFn: async () => {
      const {data} = await getExchangeRatesService(filters);
      if (data === undefined) throw new Error("No data");
      return data;
    },
  });

export const useCreateExchangeRate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: Parameters<typeof createExchangeRateService>[0]) => createExchangeRateService(body),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: EXCHANGE_RATES_KEY});
    },
  });
};

export const useUpdateExchangeRate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({id, body}: {id: string; body: Parameters<typeof updateExchangeRateService>[1]}) =>
      updateExchangeRateService(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: EXCHANGE_RATES_KEY});
    },
  });
};

export const useDeleteExchangeRate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteExchangeRateService(id),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: EXCHANGE_RATES_KEY});
    },
  });
};
